import "core-js/modules/web.dom.iterable";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import api from "../../../api/api.js";
export default {
  data: function data() {
    return {
      company: "",
      group: "",
      companySelect: [],
      groupSelect: [],
      groupDisable: true,
      leftSelect: [],
      rightSelect: [],
      removeData: [],
      addData: [],
      targetCompany: "",
      targetGroup: "",
      tgtGroupSelect: [],
      tgtGroupDisable: true,
      query: {
        input: ""
      },
      loading: false
    };
  },
  created: function created() {
    this.getCompany();
    this.getData();
  },
  methods: {
    goBack: function goBack() {
      this.$router.go(-1);
    },
    getData: function getData() {
      var _this = this;

      this.loading = true;
      var params = {
        key: this.query.input,
        usersssid: localStorage.getItem('sssid'),
        groupsssid: ""
      };
      api.getTracker(params).then(function (res) {
        _this.loading = false;

        if (res.state) {
          _this.addData = res.value;
        } else {
          _this.$message.error(res.value.text);
        }
      }).catch(function (error) {
        _this.$message.error(_this.$t('Message.reqError'));
      });
    },
    getCompany: function getCompany() {
      var _this2 = this;

      var params = {
        usersssid: localStorage.getItem('sssid')
      };
      api.getUser(params).then(function (res) {
        if (res.state) {
          _this2.companySelect = res.value;
        } else {
          _this2.$message.error(res.value.text);
        }
      }).catch(function (error) {
        _this2.$message.error(_this2.$t('Message.reqError'));
      });
    },
    getGroup: function getGroup(key) {
      var _this3 = this;

      var params = {
        usersssid: key
      };
      api.getTrackerGroup(params).then(function (res) {
        if (res.state) {
          _this3.groupSelect = res.value;
        } else {
          _this3.$message.error(res.value.text);
        }
      }).catch(function (error) {
        _this3.$message.error(_this3.$t('Message.reqError'));
      });
    },
    getTargetGroup: function getTargetGroup(key) {
      var _this4 = this;

      var params = {
        usersssid: key
      };
      api.getTrackerGroup(params).then(function (res) {
        if (res.state) {
          _this4.tgtGroupSelect = res.value;
        } else {
          _this4.$message.error(res.value.text);
        }
      }).catch(function (error) {
        _this4.$message.error(_this4.$t('Message.reqError'));
      });
    },
    changeCompany: function changeCompany(key) {
      this.groupDisable = false;
      this.group = "";
      this.groupSelect = [];
      this.getGroup(key);
    },
    changeTgtCompany: function changeTgtCompany(key) {
      this.tgtGroupDisable = false;
      this.targetGroup = "";
      this.tgtGroupSelect = [];
      this.getTargetGroup(key);
    },
    changeGroup: function changeGroup(key) {
      var _this5 = this;

      var params = {
        key: "",
        usersssid: localStorage.getItem('sssid'),
        groupsssid: key
      };
      api.getTracker(params).then(function (res) {
        if (res.state) {
          _this5.removeData = res.value;
        } else {
          _this5.$message.error(res.value.text);
        }
      }).catch(function (error) {
        _this5.$message.error(_this5.$t('Message.reqError'));
      });
    },
    handleLeftSelection: function handleLeftSelection(val) {
      this.leftSelect = val;
    },
    handlerightSelect: function handlerightSelect(val) {
      this.rightSelect = val;
    },
    onRemove: function onRemove() {
      var _this6 = this;

      if (this.leftSelect.length < 1) {
        this.$message.warning(this.$t('Message.selectItem'));
        return;
      } // 二次确认删除


      this.$confirm(this.$t('Message.confirmRemove'), this.$t('Message.tip'), {
        type: 'warning'
      }).then(function () {
        var successcount = 0;
        var failinfo = "";

        _this6.leftSelect.forEach(function (item) {
          var removeParam = {
            groupsssid: _this6.group,
            trackersssid: item.sssid
          };
          api.removeTrackerInGroup(removeParam).then(function (res) {
            if (res.state) {
              successcount++;
            } else {
              if (failinfo == "") {
                failinfo += item.trackername;
              } else {
                failinfo += "," + item.trackername;
              }
            }
          }).catch(function (error) {
            if (failinfo == "") {
              failinfo += item.trackername;
            } else {
              failinfo += "," + item.trackername;
            }
          });
        });

        setTimeout(function () {
          if (failinfo == "") {
            _this6.$message.success(_this6.$t('Message.operate'));

            _this6.company = "";
            _this6.group = "";
            _this6.groupDisable = true;
            _this6.leftSelect = [];
            _this6.removeData = [];
          } else {
            _this6.$message.error(failinfo + _this6.$t('Message.operateFail'));
          }
        }, 1000);
      }).catch(function () {});
    },
    onAdd: function onAdd() {
      var _this7 = this;

      if (this.rightSelect.length < 1) {
        this.$message.warning(this.$t('Message.selectItem'));
        return;
      }

      if (this.targetGroup == "") {
        this.$message.warning(this.$t('GroupManage.selectTargetGroup'));
        return;
      } // 二次确认删除


      this.$confirm(this.$t('Message.confirmAddGroup') + this.$refs.targetselect.selected.label + "?", this.$t('Message.tip'), {
        type: 'warning'
      }).then(function () {
        var successcount = 0;
        var failinfo = "";

        _this7.rightSelect.forEach(function (item) {
          var addParam = {
            groupsssid: _this7.targetGroup,
            trackersssid: item.sssid
          };
          api.AddTrackerInGroup(addParam).then(function (res) {
            if (res.state) {
              successcount++;
            } else {
              if (failinfo == "") {
                failinfo += item.trackername;
              } else {
                failinfo += "," + item.trackername;
              }
            }
          }).catch(function (error) {
            if (failinfo == "") {
              failinfo += item.trackername;
            } else {
              failinfo += "," + item.trackername;
            }
          });
        });

        setTimeout(function () {
          _this7.rightSelect = [];

          _this7.getData();

          if (failinfo == "") {
            _this7.$message.success(_this7.$t('Message.operate'));
          } else {
            _this7.$message.error(failinfo + _this7.$t('Message.operateFail'));
          }
        }, 1000);
      }).catch(function () {});
    },
    handleSearch: function handleSearch() {
      this.getData();
    }
  }
};